<ng-container *ngTemplateOutlet="currentView"></ng-container>
